import { useHistory } from 'react-router';

export const useHashParams = (...paramNames: string[]) => {
  const { location } = useHistory();
  const params = new URLSearchParams(location.hash.replace('#', ''));
  return paramNames.map((paramName) => params.get(paramName) || undefined);
};
